import styled from '@emotion/styled';
import Accordion from '@ep/components/Accordion';
import theme from '@ep/theme';
import { NavItem } from '@ep/types/menuData';
import { graphql, useStaticQuery } from 'gatsby';
import flatten from 'lodash.flatten';
import memoize from 'lodash.memoize';
import React from 'react';
import ContactUs from '../Header/ContactUs/ContactUs';

export interface NavDrawerProps {
  open: boolean;
  toggleDrawer: () => void;
}

const StyledNavDrawer = styled.div<NavDrawerProps>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  transition: ${theme.transitions.create(['height'])};
  height: ${({ open }) => (open ? 'calc(100vh - 5.25rem)' : 0)};
  overflow: hidden;

  @media (min-width: ${theme.breakpoints.desktopMenuBreak + 1}) {
    display: none;
  }

  ${theme.mediaQueries.mobile} {
    height: ${({ open }) => (open ? 'calc(100vh - 3.5rem)' : 0)};
  }
`;

const Divider = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
  height: 1px;
  background-color: ${theme.colors.mediumGray};
`;

const Content = styled.div`
  flex: 1;
  padding: 2rem;
  overflow: auto;

  ${theme.mediaQueries.mobile} {
    padding: 1rem;
    padding-bottom: 5rem;
  }
`;

const ContactUsContainer = styled.div`
  margin: 0 1rem 0.5rem;
  display: flex;
  justify-content: center;
`;

const flattenSubmenus = memoize((data: NavItem[]) =>
  data.map(menu =>
    menu.submenu && menu.sidemenu
      ? {
          ...menu,
          submenu: [...flatten(menu.sidemenu.map(sidemenu => sidemenu.links))],
        }
      : menu,
  ),
);

function NavDrawer({ open, toggleDrawer }: NavDrawerProps) {
  const data = useStaticQuery(graphql`
    {
      gcms {
        mobileMenu: menu(where: { position: "Mobile" }) {
          data
        }
        headerMenu: menu(where: { position: "Header" }) {
          data
        }
      }
    }
  `);

  return (
    <StyledNavDrawer open={open}>
      <Content>
        <Accordion
          prefix="header"
          toggleDrawer={toggleDrawer}
          data={flattenSubmenus(data.gcms.headerMenu.data)}
        />
        <Divider />
        <Accordion
          prefix="mobile"
          toggleDrawer={toggleDrawer}
          data={flattenSubmenus(data.gcms.mobileMenu.data)}
        />
      </Content>
    </StyledNavDrawer>
  );
}

export default React.memo(NavDrawer);
